import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SearchBar from '../../components/common/SearchBar';
import '../../styles/pages/Admin/AdminCreateBlogPage.css';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const AdminCreateBlogPage = () => {
  const navigate = useNavigate();

  const handleSelectSuggestion = (suggestion) => {
    if (suggestion.origin_id) {
      navigate(`/admin/create-blog/editor/${suggestion.origin_id}`, { state: { originName: suggestion.name, contentType: 'blog' } });
    } else {
      toast.error('Selected location is invalid.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>WeiFinders Admin Create Blog</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-create-blog-div">
        <Card className="admin-create-blog-card">
          <Card.Body>
            <h2 className="admin-create-blog-title">Create a New Blog</h2>
            <p className="admin-create-blog-instruction">
              Please select a location to associate with your blog.
            </p>
            <SearchBar
              navigate={navigate}
              variant="admin"
              onSelectSuggestion={handleSelectSuggestion}
            />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default AdminCreateBlogPage;
